import React, { useMemo, useState } from 'react';
import {
  ResponsiveContainer, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend,
} from 'recharts';
import { Card } from '../../components/ui/Card';
import { Target, Info } from 'lucide-react';
import { DATA } from '../../utils/high5MtdData';

/**
 * High5 — Ay içi (MTD) ciro hedefi takibi + önceki aya kıyas.
 *
 * Rakamlar: utils/high5MtdData.js (statik, haftalık mail yazısı da oradan okuyor).
 */

/**
 * Günlük funnel — /analytics/bq-dashboard "Daily" tablosunun (bq-analytics/daily-performance)
 * 28 Eyl 2026 anlık görüntüsü; 29 Eyl–18 Eki satırları bq_ga4_daily_summary_aem'den eklendi (son 19 Eki). 🔴 STATİK. Session Excel'le birebir; sipariş/ciro GA4 BQ
 * olduğu için Excel'in gerçekleşen ciro/TRX'inden farklı (Excel daha yüksek).
 * Satır: [tarih, session, add to cart, checkout, sipariş, ciro]
 */
const FUNNEL = [
  ['2026-07-01', 4197, 120, 32, 23, 206578],
  ['2026-07-02', 4413, 110, 31, 21, 211324],
  ['2026-07-03', 4411, 111, 35, 22, 196080],
  ['2026-07-04', 4451, 94, 27, 20, 242649],
  ['2026-07-05', 5303, 153, 31, 23, 275169],
  ['2026-07-06', 4790, 116, 28, 21, 213328],
  ['2026-07-07', 4803, 128, 45, 32, 253958],
  ['2026-07-08', 5249, 151, 42, 29, 364751],
  ['2026-07-09', 5299, 131, 39, 32, 356593],
  ['2026-07-10', 4868, 101, 31, 19, 199371],
  ['2026-07-11', 4456, 128, 34, 19, 219300],
  ['2026-07-12', 5046, 131, 34, 17, 194486],
  ['2026-07-13', 5086, 125, 32, 20, 229104],
  ['2026-07-14', 5275, 132, 34, 22, 253046],
  ['2026-07-15', 5473, 125, 30, 19, 212279],
  ['2026-07-16', 6002, 140, 33, 22, 247927],
  ['2026-07-17', 5971, 138, 36, 30, 327236],
  ['2026-07-18', 5561, 140, 43, 29, 284583],
  ['2026-07-19', 6073, 161, 36, 25, 284976],
  ['2026-07-20', 6184, 141, 57, 37, 415790],
  ['2026-07-21', 7751, 162, 48, 34, 327045],
  ['2026-07-22', 7391, 288, 40, 29, 278110],
  ['2026-07-23', 6612, 279, 34, 22, 235663],
  ['2026-07-24', 7662, 177, 52, 38, 401043],
  ['2026-07-25', 6196, 152, 35, 23, 241354],
  ['2026-07-26', 6544, 166, 38, 22, 198949],
  ['2026-07-27', 5784, 152, 45, 25, 207812],
  ['2026-07-28', 5994, 125, 36, 21, 212533],
  ['2026-07-29', 4999, 146, 34, 24, 246570],
  ['2026-07-30', 5246, 128, 36, 25, 227714],
  ['2026-07-31', 5626, 132, 54, 31, 391016],
  ['2026-08-01', 4652, 141, 32, 22, 263075],
  ['2026-08-02', 5544, 152, 19, 14, 152925],
  ['2026-08-03', 5184, 150, 37, 25, 240901],
  ['2026-08-04', 7284, 199, 66, 40, 405678],
  ['2026-08-05', 6441, 166, 53, 31, 310565],
  ['2026-08-06', 6577, 175, 46, 35, 412079],
  ['2026-08-07', 6693, 173, 40, 23, 227930],
  ['2026-08-08', 7290, 197, 59, 46, 457276],
  ['2026-08-09', 7646, 182, 38, 28, 226740],
  ['2026-08-10', 6913, 185, 60, 41, 535344],
  ['2026-08-11', 6772, 168, 50, 30, 303838],
  ['2026-08-12', 6135, 167, 62, 40, 405560],
  ['2026-08-13', 6031, 140, 42, 27, 289769],
  ['2026-08-14', 5905, 131, 38, 25, 247778],
  ['2026-08-15', 5224, 130, 34, 26, 304158],
  ['2026-08-16', 6087, 126, 39, 28, 309891],
  ['2026-08-17', 6035, 126, 44, 28, 362636],
  ['2026-08-18', 6432, 153, 36, 27, 296378],
  ['2026-08-19', 6447, 160, 42, 36, 414648],
  ['2026-08-20', 6144, 137, 40, 32, 337100],
  ['2026-08-21', 5799, 121, 37, 25, 256241],
  ['2026-08-22', 5981, 117, 27, 20, 173703],
  ['2026-08-23', 6835, 166, 30, 23, 211195],
  ['2026-08-24', 6799, 155, 35, 21, 213928],
  ['2026-08-25', 6559, 147, 35, 29, 327914],
  ['2026-08-26', 8187, 165, 48, 30, 301880],
  ['2026-08-27', 11953, 195, 49, 34, 378191],
  ['2026-08-28', 10444, 181, 47, 30, 342086],
  ['2026-08-29', 9715, 155, 34, 22, 233705],
  ['2026-08-30', 12148, 189, 50, 42, 472670],
  ['2026-08-31', 13425, 186, 39, 31, 348764],
  ['2026-09-01', 9701, 190, 43, 27, 262430],
  ['2026-09-02', 7197, 190, 56, 40, 416218],
  ['2026-09-03', 6782, 171, 33, 25, 285315],
  ['2026-09-04', 6835, 175, 39, 25, 247375],
  ['2026-09-05', 5725, 148, 37, 28, 328498],
  ['2026-09-06', 6554, 202, 53, 44, 370314],
  ['2026-09-07', 6469, 185, 56, 42, 489711],
  ['2026-09-08', 6808, 185, 51, 33, 336700],
  ['2026-09-09', 6790, 204, 61, 41, 447865],
  ['2026-09-10', 6496, 183, 52, 37, 383433],
  ['2026-09-11', 5922, 154, 38, 27, 396625],
  ['2026-09-12', 6126, 163, 43, 32, 399504],
  ['2026-09-13', 7035, 170, 39, 31, 544180],
  ['2026-09-14', 6385, 167, 40, 26, 251083],
  ['2026-09-15', 6573, 158, 46, 33, 486966],
  ['2026-09-16', 6282, 134, 32, 21, 269487],
  ['2026-09-17', 6310, 168, 44, 34, 384233],
  ['2026-09-18', 6942, 170, 40, 21, 183390],
  ['2026-09-19', 7529, 176, 35, 23, 201986],
  ['2026-09-20', 7524, 171, 49, 30, 378546],
  ['2026-09-21', 7121, 180, 39, 31, 367658],
  ['2026-09-22', 7110, 154, 45, 32, 505543],
  ['2026-09-23', 7344, 157, 35, 26, 305772],
  ['2026-09-24', 7136, 141, 43, 29, 322902],
  ['2026-09-25', 6664, 152, 37, 15, 185898],
  ['2026-09-26', 6213, 128, 32, 23, 285092],
  ['2026-09-27', 7382, 183, 41, 32, 395380],
  ['2026-09-28', 6685, 144, 41, 31, 423493],
  ['2026-09-29', 6824, 160, 45, 35, 483027],
  ['2026-09-30', 6652, 183, 47, 34, 410025],
  ['2026-10-01', 6119, 172, 42, 24, 285440],
  ['2026-10-02', 6709, 155, 40, 24, 290122],
  ['2026-10-03', 6872, 174, 39, 32, 355387],
  ['2026-10-04', 7873, 180, 35, 26, 394959],
  ['2026-10-05', 7523, 185, 42, 29, 357120],
  ['2026-10-06', 7293, 160, 37, 32, 468580],
  ['2026-10-07', 6854, 166, 48, 32, 412754],
  ['2026-10-08', 6846, 173, 44, 35, 484829],
  ['2026-10-09', 6707, 158, 38, 28, 391910],
  ['2026-10-10', 6625, 140, 28, 16, 162370],
  ['2026-10-11', 7148, 190, 35, 27, 318025],
  ['2026-10-12', 9002, 279, 65, 40, 471693],
  ['2026-10-13', 7449, 203, 61, 37, 446137],
  ['2026-10-14', 7200, 160, 47, 29, 435500],
  ['2026-10-15', 7283, 213, 58, 38, 441647],
  ['2026-10-16', 7816, 217, 62, 48, 578509],
  ['2026-10-17', 8098, 247, 58, 46, 493744],
  ['2026-10-18', 9099, 295, 71, 26, 246262],
];

const MONTH_LABEL = { '2026-07': 'Temmuz', '2026-08': 'Ağustos', '2026-09': 'Eylül', '2026-10': 'Ekim' };
const MONTHS = Object.keys(DATA);
const LINE_COLOR = { '2026-07': '#1baf7a', '2026-08': '#eb6834', '2026-09': '#8b5cf6', '2026-10': '#436AEB' };

const fmtMoney = (n) => (n == null ? '—' : `₺${Math.round(n).toLocaleString('tr-TR')}`);
const fmtM = (n) => (n == null ? '—' : `₺${(n / 1e6).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}M`);
const fmtInt = (n) => (n == null ? '—' : Math.round(n).toLocaleString('tr-TR'));
const fmtPct = (n, d = 1) => (n == null || !isFinite(n) ? '—' : `%${(n * 100).toLocaleString('tr-TR', { minimumFractionDigits: d, maximumFractionDigits: d })}`);
const fmtDelta = (n) => (n == null || !isFinite(n) ? '—' : `${n > 0 ? '+' : ''}${(n * 100).toLocaleString('tr-TR', { minimumFractionDigits: 1, maximumFractionDigits: 1 })}%`);
const fmtX = (n) => (n == null || !isFinite(n) ? '—' : n.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
const tone = (n, invert = false) => {
  if (n == null || !isFinite(n) || Math.abs(n) < 0.0005) return 'text-gray-500';
  return (n > 0) !== invert ? 'text-emerald-600' : 'text-red-600';
};

/** Ayın 1..lastDay aralığının toplamları (lastDay yoksa tüm ay). */
function sumRange(month, lastDay = 99) {
  const rows = DATA[month].filter((r) => r[0] <= lastDay);
  const s = (i) => rows.reduce((a, r) => a + (r[i] || 0), 0);
  const tRev = s(1); const aRev = s(2); const tTrx = s(3); const aTrx = s(4); const tCost = s(5); const aCost = s(6);
  return {
    days: rows.length, tRev, aRev, tTrx, aTrx, tCost, aCost,
    revAch: aRev / tRev, trxAch: aTrx / tTrx, costAch: aCost / tCost,
    aov: aTrx ? aRev / aTrx : null, roas: aCost ? aRev / aCost : null,
  };
}

const lastClosedDay = (month) => DATA[month].filter((r) => r[2] != null).reduce((m, r) => Math.max(m, r[0]), 0);

function Stat({ title, value, sub, children }) {
  return (
    <Card className="p-4">
      <div className="text-xs font-medium text-gray-500">{title}</div>
      <div className="text-2xl font-bold text-gray-900 mt-1 tabular-nums">{value}</div>
      {sub && <div className="text-xs text-gray-500 mt-1 tabular-nums">{sub}</div>}
      {children}
    </Card>
  );
}

function Bar({ ratio, marker }) {
  const w = Math.min(ratio, 1) * 100;
  return (
    <div className="relative h-2 rounded-full bg-gray-100 mt-3">
      <div className="absolute inset-y-0 left-0 rounded-full bg-[#436AEB]" style={{ width: `${w}%` }} />
      {marker != null && (
        <div className="absolute -top-1 -bottom-1 w-0.5 bg-gray-800" style={{ left: `${Math.min(marker, 1) * 100}%` }} title="Bugüne kadarki hedef" />
      )}
    </div>
  );
}

const DOW = ['Paz', 'Pzt', 'Sal', 'Çar', 'Per', 'Cum', 'Cmt'];

function FunnelTable({ month, setMonth }) {
  const rows = FUNNEL.filter((r) => r[0].startsWith(month));
  const tot = rows.reduce((a, r) => a.map((v, i) => (i === 0 ? v : v + r[i])), ['', 0, 0, 0, 0, 0]);
  const rate = (a, b) => (b ? a / b : null);
  const cells = (r, strong) => [
    fmtInt(r[1]), fmtInt(r[2]), fmtInt(r[3]), fmtInt(r[4]), fmtMoney(r[5]),
    fmtPct(rate(r[2], r[1]), 2), fmtPct(rate(r[4], r[3]), 1), fmtPct(rate(r[4], r[1]), 2),
  ].map((v, i) => (
    <td key={i} className={`px-3 py-1.5 text-right tabular-nums whitespace-nowrap ${i === 5 ? 'border-l border-gray-100 text-gray-500' : i > 5 ? 'text-gray-500' : strong ? 'text-gray-900' : 'text-gray-800'}`}>{v}</td>
  ));
  return (
    <Card className="p-0 overflow-hidden">
      <div className="px-4 py-2.5 border-b border-gray-200 flex flex-wrap items-center justify-between gap-2">
        <div>
          <div className="font-semibold text-gray-800">Günlük funnel — session · sepete ekleme · checkout · sipariş · ciro</div>
          <div className="text-xs text-gray-500">BQ Dashboard günlük tablosu (GA4 BigQuery), 1 Temmuz – 18 Ekim, statik</div>
        </div>
        <div className="flex items-center gap-1.5">
          {MONTHS.map((m) => (
            <button
              key={m}
              onClick={() => setMonth(m)}
              className={`px-2.5 py-1 rounded-lg border text-sm ${month === m ? 'bg-[#EEF2FE] border-[#436AEB] text-[#436AEB] font-medium' : 'border-gray-200 text-gray-600 hover:bg-gray-50'}`}
            >
              {MONTH_LABEL[m]}
            </button>
          ))}
        </div>
      </div>
      <div className="overflow-x-auto max-h-[560px]">
        <table className="min-w-full text-sm">
          <thead className="sticky top-0 z-10">
            <tr className="bg-gray-50 text-gray-600">
              <th className="text-left px-3 py-2 font-semibold">Tarih</th>
              <th className="text-right px-3 py-2 font-semibold">Session</th>
              <th className="text-right px-3 py-2 font-semibold whitespace-nowrap">Add to Cart</th>
              <th className="text-right px-3 py-2 font-semibold">Checkout</th>
              <th className="text-right px-3 py-2 font-semibold">Sipariş</th>
              <th className="text-right px-3 py-2 font-semibold">Ciro</th>
              <th className="text-right px-3 py-2 font-semibold whitespace-nowrap border-l border-gray-200">ATC / Session</th>
              <th className="text-right px-3 py-2 font-semibold whitespace-nowrap">Checkout → Sipariş</th>
              <th className="text-right px-3 py-2 font-semibold whitespace-nowrap">Sipariş / Session</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => {
              const d = new Date(`${r[0]}T00:00:00Z`);
              return (
                <tr key={r[0]} className="border-t border-gray-100">
                  <td className="px-3 py-1.5 text-gray-700 whitespace-nowrap tabular-nums">
                    {r[0].slice(8, 10)}.{r[0].slice(5, 7)} <span className="text-gray-400 text-xs">{DOW[d.getUTCDay()]}</span>
                  </td>
                  {cells(r)}
                </tr>
              );
            })}
            <tr className="border-t-2 border-gray-200 bg-gray-50 font-semibold">
              <td className="px-3 py-2 text-gray-900">Toplam</td>
              {cells(tot, true)}
            </tr>
          </tbody>
        </table>
      </div>
    </Card>
  );
}

const MON_TR = ['Oca', 'Şub', 'Mar', 'Nis', 'May', 'Haz', 'Tem', 'Ağu', 'Eyl', 'Eki', 'Kas', 'Ara'];
const fmtD = (ymd) => `${Number(ymd.slice(8, 10))} ${MON_TR[Number(ymd.slice(5, 7)) - 1]}`;

/** FUNNEL satırlarını anahtara göre toplar: [{ key, from, to, days, v:[_, session, atc, checkout, sipariş, ciro] }] */
function groupFunnel(keyOf) {
  const out = [];
  FUNNEL.forEach((r) => {
    const k = keyOf(r[0]);
    let g = out[out.length - 1];
    if (!g || g.key !== k) { g = { key: k, from: r[0], to: r[0], days: 0, v: ['', 0, 0, 0, 0, 0] }; out.push(g); }
    g.to = r[0]; g.days += 1;
    for (let i = 1; i <= 5; i += 1) g.v[i] += r[i];
  });
  return out;
}

// ISO hafta: pazartesi başlangıç (UTC, tarih kayması olmasın)
const weekStart = (ymd) => {
  const d = new Date(`${ymd}T00:00:00Z`);
  d.setUTCDate(d.getUTCDate() - ((d.getUTCDay() + 6) % 7));
  return d.toISOString().slice(0, 10);
};

function FunnelSummary() {
  const [mode, setMode] = useState('week');
  const groups = useMemo(() => (mode === 'week' ? groupFunnel(weekStart) : groupFunnel((d) => d.slice(0, 7))), [mode]);
  const rate = (a, b) => (b ? a / b : null);
  const tot = groups.reduce((a, g) => a.map((v, i) => (i === 0 ? v : v + g.v[i])), ['', 0, 0, 0, 0, 0]);
  const totDays = groups.reduce((a, g) => a + g.days, 0);
  const cells = (v, days, strong) => [
    fmtInt(v[1]), fmtInt(v[2]), fmtInt(v[3]), fmtInt(v[4]), fmtMoney(v[5]),
    fmtInt(v[1] / days), fmtMoney(v[5] / days),
    fmtPct(rate(v[2], v[1]), 2), fmtPct(rate(v[4], v[3]), 1), fmtPct(rate(v[4], v[1]), 2),
  ].map((x, i) => (
    <td key={i} className={`px-3 py-1.5 text-right tabular-nums whitespace-nowrap ${i === 5 || i === 7 ? 'border-l border-gray-100' : ''} ${i >= 5 ? 'text-gray-500' : strong ? 'text-gray-900' : 'text-gray-800'}`}>{x}</td>
  ));
  const label = (g) => {
    if (mode === 'month') return `${MONTH_LABEL[g.key] || g.key}${g.days < new Date(Date.UTC(+g.key.slice(0, 4), +g.key.slice(5, 7), 0)).getUTCDate() ? ` (1–${Number(g.to.slice(8, 10))})` : ''}`;
    return `${fmtD(g.from)} – ${fmtD(g.to)}`;
  };
  return (
    <Card className="p-0 overflow-hidden">
      <div className="px-4 py-2.5 border-b border-gray-200 flex flex-wrap items-center justify-between gap-2">
        <div>
          <div className="font-semibold text-gray-800">Funnel toplamları — {mode === 'week' ? 'haftalık' : 'aylık'}</div>
          <div className="text-xs text-gray-500">Günlük tablonun toplamı · haftalar pazartesi–pazar · eksik gün içeren dönem ayrıca işaretli</div>
        </div>
        <div className="flex items-center gap-1.5">
          {[['week', 'Haftalık'], ['month', 'Aylık']].map(([k, l]) => (
            <button
              key={k}
              onClick={() => setMode(k)}
              className={`px-2.5 py-1 rounded-lg border text-sm ${mode === k ? 'bg-[#EEF2FE] border-[#436AEB] text-[#436AEB] font-medium' : 'border-gray-200 text-gray-600 hover:bg-gray-50'}`}
            >
              {l}
            </button>
          ))}
        </div>
      </div>
      <div className="overflow-x-auto max-h-[560px]">
        <table className="min-w-full text-sm">
          <thead className="sticky top-0 z-10">
            <tr className="bg-gray-50 text-gray-600">
              <th className="text-left px-3 py-2 font-semibold">{mode === 'week' ? 'Hafta' : 'Ay'}</th>
              <th className="text-right px-3 py-2 font-semibold">Session</th>
              <th className="text-right px-3 py-2 font-semibold whitespace-nowrap">Add to Cart</th>
              <th className="text-right px-3 py-2 font-semibold">Checkout</th>
              <th className="text-right px-3 py-2 font-semibold">Sipariş</th>
              <th className="text-right px-3 py-2 font-semibold">Ciro</th>
              <th className="text-right px-3 py-2 font-semibold whitespace-nowrap border-l border-gray-200">Günlük ort. session</th>
              <th className="text-right px-3 py-2 font-semibold whitespace-nowrap">Günlük ort. ciro</th>
              <th className="text-right px-3 py-2 font-semibold whitespace-nowrap border-l border-gray-200">ATC / Session</th>
              <th className="text-right px-3 py-2 font-semibold whitespace-nowrap">Checkout → Sipariş</th>
              <th className="text-right px-3 py-2 font-semibold whitespace-nowrap">Sipariş / Session</th>
            </tr>
          </thead>
          <tbody>
            {groups.map((g) => (
              <tr key={g.key} className="border-t border-gray-100">
                <td className="px-3 py-1.5 text-gray-700 whitespace-nowrap tabular-nums">
                  {label(g)}
                  {mode === 'week' && g.days < 7 && <span className="ml-1.5 text-[11px] text-gray-400">{g.days} gün</span>}
                </td>
                {cells(g.v, g.days)}
              </tr>
            ))}
            <tr className="border-t-2 border-gray-200 bg-gray-50 font-semibold">
              <td className="px-3 py-2 text-gray-900 whitespace-nowrap">Toplam <span className="text-[11px] font-normal text-gray-500">{fmtD(FUNNEL[0][0])} – {fmtD(FUNNEL[FUNNEL.length - 1][0])}</span></td>
              {cells(tot, totDays, true)}
            </tr>
          </tbody>
        </table>
      </div>
    </Card>
  );
}

/**
 * Haftalık hedef vs gerçekleşen — DATA'dan (müşterinin Excel'i), BQ DEĞİL.
 * Yalnız kapanmış günler; yürüyen haftada hedef de o günlere kırpılır.
 */
function ActualWeekly() {
  const weeks = useMemo(() => {
    const out = [];
    MONTHS.forEach((m) => DATA[m].forEach((r) => {
      if (r[2] == null) return;
      const ymd = `${m}-${String(r[0]).padStart(2, '0')}`;
      const k = weekStart(ymd);
      let g = out[out.length - 1];
      if (!g || g.key !== k) { g = { key: k, from: ymd, to: ymd, days: 0, v: [0, 0, 0, 0, 0, 0, 0] }; out.push(g); }
      g.to = ymd; g.days += 1;
      for (let i = 1; i <= 6; i += 1) g.v[i] += r[i];
    }));
    return out.reverse();
  }, []);
  const tot = weeks.reduce((a, g) => a.map((v, i) => v + g.v[i]), [0, 0, 0, 0, 0, 0, 0]);
  const hgo = (a, t) => (t ? a / t : null);
  const hgoCls = (x, invert = false) => (x == null ? 'text-gray-400' : (x >= 1) !== invert ? 'text-emerald-600' : 'text-red-600');
  const cells = (v, strong) => {
    const td = (x, cls = '') => <td className={`px-3 py-1.5 text-right tabular-nums whitespace-nowrap ${cls}`}>{x}</td>;
    const main = strong ? 'text-gray-900 font-semibold' : 'text-gray-900';
    return [
      td(fmtMoney(v[1]), 'text-gray-500'), td(fmtMoney(v[2]), main), td(fmtPct(hgo(v[2], v[1]), 0), `font-semibold ${hgoCls(hgo(v[2], v[1]))}`),
      td(fmtInt(v[3]), 'text-gray-500 border-l border-gray-100'), td(fmtInt(v[4]), main), td(fmtPct(hgo(v[4], v[3]), 0), `font-semibold ${hgoCls(hgo(v[4], v[3]))}`),
      td(fmtMoney(v[4] ? v[2] / v[4] : null), 'text-gray-800 border-l border-gray-100'),
      td(fmtMoney(v[5]), 'text-gray-500 border-l border-gray-100'), td(fmtMoney(v[6]), main), td(fmtPct(hgo(v[6], v[5]), 0), `font-semibold ${hgoCls(hgo(v[6], v[5]), true)}`),
      td(fmtX(v[6] ? v[2] / v[6] : null), 'text-gray-800 border-l border-gray-100'),
    ];
  };
  const last = weeks[0];
  return (
    <Card className="p-0 overflow-hidden">
      <div className="px-4 py-2.5 border-b border-gray-200">
        <div className="font-semibold text-gray-800">Haftalık hedef vs gerçekleşen</div>
        <div className="text-xs text-gray-500">
          Günlük hedef tablosundaki gerçekleşenler (BQ değil) · haftalar pazartesi–pazar · eksik haftada hedef de aynı günlere kırpıldı · en yeni hafta üstte
        </div>
      </div>
      <div className="overflow-x-auto max-h-[620px]">
        <table className="min-w-full text-sm">
          <thead className="sticky top-0 z-10">
            <tr className="bg-gray-50 text-gray-600">
              <th className="text-left px-3 py-2 font-semibold">Hafta</th>
              <th className="text-right px-3 py-2 font-semibold whitespace-nowrap">Hedef ciro</th>
              <th className="text-right px-3 py-2 font-semibold whitespace-nowrap">Gerç. ciro</th>
              <th className="text-right px-3 py-2 font-semibold">HGO</th>
              <th className="text-right px-3 py-2 font-semibold whitespace-nowrap border-l border-gray-200">Hedef TRX</th>
              <th className="text-right px-3 py-2 font-semibold whitespace-nowrap">Gerç. TRX</th>
              <th className="text-right px-3 py-2 font-semibold">HGO</th>
              <th className="text-right px-3 py-2 font-semibold border-l border-gray-200">AOV</th>
              <th className="text-right px-3 py-2 font-semibold whitespace-nowrap border-l border-gray-200">Hedef cost</th>
              <th className="text-right px-3 py-2 font-semibold whitespace-nowrap">Gerç. cost</th>
              <th className="text-right px-3 py-2 font-semibold">HGO</th>
              <th className="text-right px-3 py-2 font-semibold border-l border-gray-200">ROAS</th>
            </tr>
          </thead>
          <tbody>
            {weeks.map((g) => (
              <tr key={g.key} className={`border-t border-gray-100 ${g === last ? 'bg-[#EEF2FE]/60' : ''}`}>
                <td className="px-3 py-1.5 text-gray-700 whitespace-nowrap tabular-nums">
                  {fmtD(g.from)} – {fmtD(g.to)}
                  {g.days < 7 && <span className="ml-1.5 text-[11px] text-gray-400">{g.days} gün</span>}
                </td>
                {cells(g.v)}
              </tr>
            ))}
            <tr className="border-t-2 border-gray-200 bg-gray-50">
              <td className="px-3 py-2 text-gray-900 font-semibold whitespace-nowrap">Toplam <span className="text-[11px] font-normal text-gray-500">{fmtD(weeks[weeks.length - 1].from)} – {fmtD(last.to)}</span></td>
              {cells(tot, true)}
            </tr>
          </tbody>
        </table>
      </div>
    </Card>
  );
}

export default function High5MtdTarget() {
  const cur = MONTHS[MONTHS.length - 1];
  const prev = MONTHS[MONTHS.length - 2];
  const day = lastClosedDay(cur);
  const [funnelMonth, setFunnelMonth] = useState(cur);

  const mtd = useMemo(() => sumRange(cur, day), [cur, day]);
  const full = useMemo(() => sumRange(cur), [cur]);
  const cmp = useMemo(() => sumRange(prev, day), [prev, day]);
  // Aylar soldan sağa eskiden yeniye, hepsi ayın aynı 1..day günleri
  const cols = useMemo(() => MONTHS.map((m) => ({ m, s: sumRange(m, day) })), [day]);
  const others = MONTHS.filter((m) => m !== cur).reverse(); // fark sütunları: önce bir önceki ay

  const remainingDays = DATA[cur].length - day;
  const gap = full.tRev - mtd.aRev;
  const runRate = (mtd.aRev / day) * DATA[cur].length;
  const curLabel = MONTH_LABEL[cur];
  const cmpLabel = MONTH_LABEL[prev];

  // Kümülatif ciro: ayın günü ekseninde (1..31) her ayın gerçekleşeni + cari ay hedefi
  const chart = useMemo(() => {
    const maxDays = Math.max(...MONTHS.map((m) => DATA[m].length));
    const acc = Object.fromEntries(MONTHS.map((m) => [m, 0]));
    let cT = 0;
    const out = [];
    for (let d = 1; d <= maxDays; d += 1) {
      const pt = { day: d };
      for (const m of MONTHS) {
        const r = DATA[m].find((x) => x[0] === d);
        if (r && r[2] != null) { acc[m] += r[2]; pt[m] = acc[m]; } else pt[m] = null;
        if (m === cur && r) { cT += r[1]; pt.target = cT; }
      }
      out.push(pt);
    }
    return out;
  }, [cur]);

  const rows = [
    { label: 'Hedef ciro', k: 'tRev', f: fmtMoney, neutral: true },
    { label: 'Gerçekleşen ciro', k: 'aRev', f: fmtMoney, bold: true },
    { label: 'Ciro hedef gerçekleşme', k: 'revAch', f: fmtPct, ach: true },
    { label: 'Hedef TRX', k: 'tTrx', f: fmtInt, neutral: true },
    { label: 'Gerçekleşen TRX', k: 'aTrx', f: fmtInt, bold: true },
    { label: 'TRX hedef gerçekleşme', k: 'trxAch', f: fmtPct, ach: true },
    { label: 'AOV', k: 'aov', f: fmtMoney },
    { label: 'Hedef cost', k: 'tCost', f: fmtMoney, neutral: true },
    { label: 'Gerçekleşen cost', k: 'aCost', f: fmtMoney, bold: true, invert: true },
    { label: 'Cost hedef kullanımı', k: 'costAch', f: fmtPct, invert: true },
    { label: 'ROAS (ciro ÷ cost)', k: 'roas', f: fmtX },
  ];

  return (
    <div className="p-6 space-y-5 max-w-full">
      <div>
        <h1 className="text-xl font-bold text-gray-900 flex items-center gap-2">
          <Target className="w-5 h-5 text-[#436AEB]" />
          {curLabel} MTD — Ciro Hedefi
        </h1>
        <p className="text-sm text-gray-500 mt-1">
          1–{day} {curLabel} kapanmış günler · kalan {remainingDays} gün · kaynak: günlük hedef tablosu (statik)
        </p>
      </div>

      {/* Üst kartlar */}
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-3">
        <Stat
          title={`Aylık ciro hedefi · ${curLabel}`}
          value={fmtM(full.tRev)}
          sub={`Gerçekleşen ${fmtM(mtd.aRev)} · ayın ${fmtPct(mtd.aRev / full.tRev)}'i`}
        >
          <Bar ratio={mtd.aRev / full.tRev} marker={mtd.tRev / full.tRev} />
          <div className="text-[11px] text-gray-500 mt-1.5">Çizgi: {day}. güne kadar olması gereken ({fmtPct(mtd.tRev / full.tRev)})</div>
        </Stat>
        <Stat
          title={`MTD hedef (1–${day})`}
          value={fmtPct(mtd.revAch)}
          sub={`${fmtM(mtd.aRev)} / ${fmtM(mtd.tRev)} · açık ${fmtM(mtd.tRev - mtd.aRev)}`}
        />
        <Stat
          title={`Önceki aya göre (1–${day} ${cmpLabel})`}
          value={<span className={tone(mtd.aRev / cmp.aRev - 1)}>{fmtDelta(mtd.aRev / cmp.aRev - 1)}</span>}
          sub={`${cmpLabel} aynı günler ${fmtM(cmp.aRev)} · hedefin ${fmtPct(cmp.revAch)}'i`}
        />
        <Stat
          title="Ay sonu"
          value={fmtM(runRate)}
          sub={`Bu hızla ay sonu tahmini · hedefe ${fmtM(gap)} kaldı (${remainingDays} günde, günde ${fmtM(gap / remainingDays)})`}
        />
      </div>

      {/* Üç ay yan yana */}
      <Card className="p-0 overflow-hidden">
        <div className="px-4 py-2.5 border-b border-gray-200">
          <div className="font-semibold text-gray-800">{MONTHS.map((m) => MONTH_LABEL[m]).join(' · ')} — yan yana</div>
          <div className="text-xs text-gray-500">Her ayın aynı günleri (1–{day}); fark sütunları {curLabel}'ün önceki aylara göre değişimi</div>
        </div>
        <div className="overflow-x-auto">
          <table className="min-w-full text-sm">
            <thead>
              <tr className="bg-gray-50 text-gray-600">
                <th className="text-left px-4 py-2 font-semibold">Metrik</th>
                {cols.map(({ m }) => (
                  <th key={m} className={`text-right px-4 py-2 font-semibold whitespace-nowrap ${m === cur ? 'bg-[#EEF2FE] text-[#436AEB]' : ''}`}>
                    {MONTH_LABEL[m]}<div className="text-[10px] font-normal opacity-70">1–{day}</div>
                  </th>
                ))}
                {others.map((m) => (
                  <th key={m} className="text-right px-4 py-2 font-semibold whitespace-nowrap border-l border-gray-200">
                    {curLabel.slice(0, 3)} vs {MONTH_LABEL[m].slice(0, 3)}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {rows.map((r) => {
                const a = mtd[r.k];
                const pct = r.ach || r.k === 'costAch';
                return (
                  <tr key={r.k} className="border-t border-gray-100">
                    <td className={`px-4 py-2 whitespace-nowrap ${r.bold ? 'font-semibold text-gray-900' : 'text-gray-700'}`}>{r.label}</td>
                    {cols.map(({ m, s: v }) => (
                      <td key={m} className={`px-4 py-2 text-right tabular-nums whitespace-nowrap ${m === cur ? 'bg-[#EEF2FE]/60' : ''} ${r.bold ? 'font-semibold text-gray-900' : 'text-gray-800'}`}>
                        {r.f(v[r.k])}
                      </td>
                    ))}
                    {others.map((m) => {
                      const b = cols.find((c) => c.m === m).s[r.k];
                      const d = pct ? a - b : a / b - 1;
                      return (
                        <td key={m} className={`px-4 py-2 text-right tabular-nums font-semibold whitespace-nowrap border-l border-gray-100 ${r.neutral ? 'text-gray-500' : tone(d, r.invert)}`}>
                          {pct
                            ? `${d > 0 ? '+' : ''}${(d * 100).toLocaleString('tr-TR', { maximumFractionDigits: 1, minimumFractionDigits: 1 })} puan`
                            : fmtDelta(d)}
                        </td>
                      );
                    })}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </Card>

      {/* Kümülatif grafik */}
      <Card className="p-4">
        <div className="font-semibold text-gray-800">Kümülatif ciro — ayın günü</div>
        <div className="text-xs text-gray-500 mb-3">Her ayın gerçekleşeni ve {curLabel} hedefi aynı gün ekseninde</div>
        <div style={{ height: 320 }}>
          <ResponsiveContainer width="100%" height="100%">
            <LineChart data={chart} margin={{ top: 5, right: 16, left: 8, bottom: 0 }}>
              <CartesianGrid stroke="#F3F4F6" vertical={false} />
              <XAxis dataKey="day" tick={{ fontSize: 11, fill: '#6B7280' }} tickLine={false} axisLine={{ stroke: '#E5E7EB' }} />
              <YAxis tickFormatter={(v) => `₺${(v / 1e6).toLocaleString('tr-TR', { maximumFractionDigits: 1 })}M`} tick={{ fontSize: 11, fill: '#6B7280' }} tickLine={false} axisLine={false} width={56} />
              <Tooltip
                formatter={(v, n) => [fmtMoney(v), n]}
                labelFormatter={(d) => `Ayın ${d}. günü`}
                contentStyle={{ borderRadius: 12, border: '1px solid #E5E7EB', fontSize: 12 }}
              />
              <Legend wrapperStyle={{ fontSize: 12 }} />
              <Line type="monotone" dataKey="target" name={`${curLabel} hedef`} stroke="#9CA3AF" strokeDasharray="5 4" strokeWidth={2} dot={false} connectNulls={false} />
              {MONTHS.map((m) => (
                <Line key={m} type="monotone" dataKey={m} name={MONTH_LABEL[m]} stroke={LINE_COLOR[m]} strokeWidth={m === cur ? 3 : 2} dot={false} />
              ))}
            </LineChart>
          </ResponsiveContainer>
        </div>
      </Card>

      {/* Tüm ay: Temmuz/Ağustos kapanmış ay, cari ay tüm ay hedefi + şu ana kadar gerçekleşen */}
      <Card className="p-0 overflow-hidden">
        <div className="px-4 py-2.5 border-b border-gray-200">
          <div className="font-semibold text-gray-800">Aylık toplam — tüm ay</div>
          <div className="text-xs text-gray-500">Önceki aylar kapanmış haliyle; {curLabel} tüm ay hedefi ve 1–{day} gerçekleşeni</div>
        </div>
        <div className="overflow-x-auto">
          <table className="min-w-full text-sm">
            <thead>
              <tr className="bg-gray-50 text-gray-600">
                <th className="text-left px-4 py-2 font-semibold">Ay</th>
                <th className="text-right px-4 py-2 font-semibold whitespace-nowrap">Hedef ciro</th>
                <th className="text-right px-4 py-2 font-semibold whitespace-nowrap">Gerçekleşen ciro</th>
                <th className="text-right px-4 py-2 font-semibold whitespace-nowrap">Gerçekleşme</th>
                <th className="text-right px-4 py-2 font-semibold whitespace-nowrap border-l border-gray-200">Hedef TRX</th>
                <th className="text-right px-4 py-2 font-semibold whitespace-nowrap">Gerçekleşen TRX</th>
                <th className="text-right px-4 py-2 font-semibold whitespace-nowrap border-l border-gray-200">Hedef cost</th>
                <th className="text-right px-4 py-2 font-semibold whitespace-nowrap">Gerçekleşen cost</th>
                <th className="text-right px-4 py-2 font-semibold whitespace-nowrap">ROAS</th>
              </tr>
            </thead>
            <tbody>
              {MONTHS.map((m) => {
                const v = sumRange(m);
                const open = m === cur && day < DATA[m].length;
                return (
                  <tr key={m} className={`border-t border-gray-100 ${m === cur ? 'bg-[#EEF2FE]/60' : ''}`}>
                    <td className="px-4 py-2 font-semibold text-gray-900 whitespace-nowrap">
                      {MONTH_LABEL[m]}
                      {open && <span className="ml-1.5 text-[11px] font-normal text-gray-500">gerçekleşen 1–{day}</span>}
                    </td>
                    <td className="px-4 py-2 text-right tabular-nums text-gray-800">{fmtMoney(v.tRev)}</td>
                    <td className="px-4 py-2 text-right tabular-nums font-semibold text-gray-900">{fmtMoney(v.aRev)}</td>
                    <td className={`px-4 py-2 text-right tabular-nums font-semibold ${v.revAch >= 1 ? 'text-emerald-600' : 'text-gray-800'}`}>{fmtPct(v.revAch)}</td>
                    <td className="px-4 py-2 text-right tabular-nums text-gray-800 border-l border-gray-100">{fmtInt(v.tTrx)}</td>
                    <td className="px-4 py-2 text-right tabular-nums text-gray-900">{fmtInt(v.aTrx)}</td>
                    <td className="px-4 py-2 text-right tabular-nums text-gray-800 border-l border-gray-100">{fmtMoney(v.tCost)}</td>
                    <td className="px-4 py-2 text-right tabular-nums text-gray-900">{fmtMoney(v.aCost)}</td>
                    <td className="px-4 py-2 text-right tabular-nums text-gray-800">{fmtX(v.roas)}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </Card>

      <ActualWeekly />

      <FunnelTable month={funnelMonth} setMonth={setFunnelMonth} />
      <FunnelSummary />

      <Card className="p-4">
        <div className="flex items-start gap-2 text-sm text-gray-600">
          <Info className="w-4 h-4 mt-0.5 text-gray-400 shrink-0" />
          <div>
            Rakamlar günlük hedef tablosundan elle girildi, canlı veriye bağlı değil. Aylar ayın
            aynı günleri üzerinden (1–{day}) kıyaslanıyor. ROAS = toplam ciro ÷ toplam cost
            (Google Ads + Meta + RTB). Fatura sütunları dahil değil.
          </div>
        </div>
      </Card>
    </div>
  );
}
